var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbFinanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5749 11.3393H17.1323L17.2931 10.8057L17.7181 9.39494L18.0093 8.42857H17H15.7418C15.7156 8.33793 15.6869 8.24863 15.6556 8.16071H16.5749H17.1323L17.2931 7.62708L17.7181 6.21637L18.0093 5.25H17H8.45277H7.89893L7.73597 5.77933L7.30168 7.19004L7.00286 8.16071H8.01848H10.4579C11.0912 8.16071 11.5281 8.26147 11.817 8.409L11.8169 8.40909L11.8281 8.41458C11.8376 8.41921 11.8469 8.42387 11.8561 8.42857H8.42505H7.86772L7.70694 8.9622L7.28189 10.3729L6.99072 11.3393H8H11.8942C11.8635 11.3566 11.8316 11.3734 11.7985 11.3899C11.5076 11.532 11.0917 11.625 10.5133 11.625H8.25873H7.50244L7.50875 12.3813L7.51799 13.4884L7.52034 13.7692L7.70657 13.9795L12.5947 19.4973L12.8185 19.75H13.1561H15.2536H16.0036V19V18.8929V18.6074L15.8138 18.3942L12.2694 14.4125C12.7943 14.3204 13.2687 14.1742 13.685 13.9657C14.4661 13.5775 15.0681 13.0202 15.4349 12.2813C15.5852 11.9815 15.7017 11.6671 15.7854 11.3393H16.5749ZM23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z",
    fill: "#ECECEC",
    stroke: "#ECECEC",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbFinanceIcon);
export default __webpack_public_path__ + "static/media/SBFinanceIcon.cb916eaff34f225a37653de41121bb5c.svg";
export { ForwardRef as ReactComponent };